import React, { createContext, useContext } from "react";

const OfflineContext = createContext({});

export function OfflineProvider({ children }) {
  return (
    <OfflineContext.Provider value={{ refreshCount: async () => {} }}>
      {children}
    </OfflineContext.Provider>
  );
}

export function useOffline() {
  return useContext(OfflineContext);
}
